import { ExternalLink, LoaderCircle } from "lucide-react";
import { useRenewSubPortalSession } from "./useRenewSubPortalSession";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import toast from "react-hot-toast";
import { useQueryClient } from "@tanstack/react-query";

export default function RenewSubscriptionButton({
  text = "Renew plan",
  className,
  ...props
}) {
  const { mutate, isLoading } = useRenewSubPortalSession();
  const queryClient = useQueryClient();
  function onClick() {
    mutate(undefined, {
      onSuccess: () => {
        toast.success("Subscription renewed successfully!");
        queryClient.invalidateQueries(["cancellation-date"]);
      },
    });
  }

  return (
    <Button onClick={onClick} className={cn("gap-1", className)} {...props}>
      {text}
      {isLoading && <LoaderCircle className="h-4 w-4 animate-spin" />}
    </Button>
  );
}
